import { create } from 'zustand';
import type { AdminUser, LoginResponse } from '@/api/auth';

interface AuthState {
    token: string | null;
    permissions: string[];
    adminUser: AdminUser | null;
    isAuthenticated: boolean;

    login: (data: LoginResponse) => void;
    logout: () => void;
    setPermissions: (permissions: string[]) => void;
    setAdminUser: (user: AdminUser) => void;
}

function safeJsonParse<T>(key: string, fallback: T): T {
    try {
        const raw = localStorage.getItem(key);
        if (!raw || raw === 'undefined') return fallback;
        return JSON.parse(raw) as T;
    } catch {
        return fallback;
    }
}

export const useAuthStore = create<AuthState>((set) => ({
    token: localStorage.getItem('admin_token'),
    permissions: safeJsonParse<string[]>('admin_permissions', []),
    adminUser: safeJsonParse<AdminUser | null>('admin_user', null),
    isAuthenticated: !!localStorage.getItem('admin_token'),

    login: (data: LoginResponse) => {
        localStorage.setItem('admin_token', data.token);
        localStorage.setItem('admin_permissions', JSON.stringify(data.permissions));
        localStorage.setItem('admin_user', JSON.stringify(data.adminUser));
        set({
            token: data.token,
            permissions: data.permissions,
            adminUser: data.adminUser,
            isAuthenticated: true,
        });
    },

    logout: () => {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_permissions');
        localStorage.removeItem('admin_user');
        set({
            token: null,
            permissions: [],
            adminUser: null,
            isAuthenticated: false,
        });
    },

    setPermissions: (permissions: string[]) => {
        localStorage.setItem('admin_permissions', JSON.stringify(permissions));
        set({ permissions });
    },

    setAdminUser: (user: AdminUser) => {
        localStorage.setItem('admin_user', JSON.stringify(user));
        set({ adminUser: user });
    },
}));
